import submit from "submit-form";

const loadRegex = /^[0-9]+\.(?:\d{1,5})$|^[0-9]+$/;
const wholeNumberRegex = /^0*[1-9]\d*$/;

export const goalValidation = (goalType, details, assert, flash) => {
  try {
    const {
      customName,
      customTarget,
      customIcon,
      targetSteps,
      targetWeight,
      targetSleep,
      targetName,
      targetLoad,
      targetReps,
    } = details;

    if (goalType === "bodyWeight") {
      assert(targetWeight, 400, "Weight is required");
      assert(loadRegex.test(targetWeight), 400, "Weight must be a number");
    }
    if (goalType === "steps") {
      assert(targetSteps, 400, "Steps are required");
      assert(wholeNumberRegex.test(targetSteps), 400, "Steps must be a number");
    }
    if (goalType === "sleep") {
      assert(targetSleep, 400, "Sleep time is required");
      assert(wholeNumberRegex.test(targetSleep), 400, "Sleep must be a number");
    }
    if (goalType === "custom") {
      validateCustomGoal(customName, customTarget, customIcon, assert);
    }
    if (goalType === "personalRecord") {
      validatePersonalRecordGoal(targetName, targetLoad, targetReps, assert);
    }

    return true;
  } catch (error) {
    flash("error", error.message);
    submit("/actions/refresh");
    return false;
  }
};

const validateCustomGoal = (customName, customTarget, customIcon, assert) => {
  assert(customName, 400, "Goal Name Required");
  assert(customTarget, 400, "Goal Name Required");
  assert(customIcon, 400, "Goal Icon Required");
  assert(
    customName.trim().length > 3,
    400,
    "Goal Name should be at least 3 characters long"
  );
  assert(
    customTarget.trim().length > 2,
    400,
    "Goal Target should be at least 2 characters long"
  );
};

const validatePersonalRecordGoal = (
  targetName,
  targetLoad,
  targetReps,
  assert
) => {
  assert(targetName, 400, "Exercise Name Required");
  assert(targetLoad, 400, "Target Load Required");
  assert(loadRegex.test(targetLoad), 400, "Target Load Must be a Number");
  assert(targetReps, 400, "Target Reps Required");
  assert(
    wholeNumberRegex.test(targetReps),
    400,
    "Target Reps Must be a Number"
  );
};
